import type { AsyncOption } from "@/components/async-combobox";

/**
 * Fetch product options from the server for AsyncCombobox
 * @param term - Search term
 * @returns Promise with array of AsyncOptions
 */
export async function fetchProductOptions(term: string): Promise<AsyncOption[]> {
  const params = new URLSearchParams();
  params.set('term', term || '');
  const res = await fetch(`/products/search?${params.toString()}`);
  if (!res.ok) return [];
  const data = (await res.json()) as { id: number; value: number; label: string }[];
  return data.map((p) => ({ value: p.id, label: p.label }));
}
